import { connectToggleRefinement } from "react-instantsearch-dom";

const VirtualToggleRefinement: React.FunctionComponent<any> = () => null;

export default connectToggleRefinement(VirtualToggleRefinement);
